import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import {Iconfont} from '../../../../components/icon/iconfont'

export default props => {
    useStyles(classes)
    return <div className={classes.Header}>
        <Iconfont className={classes.Back} onClick={props?.onBack}>&#xe690;</Iconfont>
        <div className={classes.Title}>
            {props.children}
        </div>
        <div className={classes.Tools}>
            {
                props.extra
            }
        </div>
    </div>
}